module.exports = __webpack_public_path__ + "static/img/19.63d3458.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qingka3/19.jpg
// module id = pOJz
// module chunks = 16